// Returns ISO date string for the Monday of the week containing the given date
export function getMondayOfWeek(date: Date = new Date()): string {
  const d = new Date(date)
  const day = d.getDay()                     // 0=Sunday, 1=Monday, ...
  const diff = day === 0 ? -6 : 1 - day       // adjust to Monday
  d.setDate(d.getDate() + diff)
  // Use local date parts to avoid UTC offset shifting the date
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const dayStr = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${dayStr}`
}

export const DAY_NAMES: Record<number, string> = {
  0: 'Monday', 1: 'Tuesday', 2: 'Wednesday', 3: 'Thursday',
  4: 'Friday', 5: 'Saturday', 6: 'Sunday',
}
